import { motion } from "framer-motion";

export function Section({ children, className = "", label, title, subtitle, testId }) {
  return (
    <section className={`relative py-20 md:py-28 cv-auto ${className}`} data-testid={testId}>
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        {(label || title || subtitle) && (
          <div className="max-w-3xl mb-14">
            {label && (
              <motion.p
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5 }}
                className="section-label mb-4"
              >
                <span className="inline-block w-8 h-px bg-gold align-middle mr-3" />
                {label}
              </motion.p>
            )}
            {title && (
              <motion.h2
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="serif-display text-4xl md:text-5xl lg:text-6xl text-foreground"
              >
                {title}
              </motion.h2>
            )}
            {subtitle && (
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="mt-5 text-base md:text-lg text-foreground/70 leading-relaxed max-w-2xl"
              >
                {subtitle}
              </motion.p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}

export function Reveal({ children, delay = 0, y = 20 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
